import * as _ from 'lodash-es';
import {
  REFERRAL_SOURCE_EXTERNAL,
  REFERRAL_SOURCE_QUERY_PARAM,
} from 'services/referrals/referral-source.constants';
import { getUrlLocale } from 'utils/routing';

const appendPath = (...paths: (string | number | undefined)[]) => {
  const urlLocale = getUrlLocale();
  return _.join([urlLocale && `/${urlLocale}`, ...paths], '/');
};

const BASE_URL = {
  getPath: (): string => appendPath(''),
};

const HOME = {
  getPath: (): string => appendPath('referrals'),
};

const REFERRAL_DETAILS = {
  getPath: (id: string, opts?: { isExternalReferral?: boolean }): string => {
    const base = appendPath('referral', id);
    return opts?.isExternalReferral
      ? `${base}?${REFERRAL_SOURCE_QUERY_PARAM}=${REFERRAL_SOURCE_EXTERNAL}`
      : base;
  },
};

const LOGIN = {
  getPath: (): string => appendPath('login'),
};

const REGISTER = {
  getPath: (): string => appendPath('register'),
};

const ACCOUNT = {
  path: 'account',
  getPath: (): string => appendPath(ACCOUNT.path),
};

const ACCOUNT_DETAILS = {
  getPath: (): string => appendPath(ACCOUNT.path, 'details'),
};

const ACCOUNT_LANGUAGE = {
  getPath: (): string => appendPath(ACCOUNT.path, 'language'),
};

const FORGOT_PASSWORD = {
  getPath: (): string => appendPath('forgot-password'),
};

const CHANGE_PASSWORD = {
  getPath: (): string => appendPath('change-password'),
};

const MY_SITES = {
  getPath: (): string => appendPath(ACCOUNT.path, 'my-sites'),
};

const ACCOUNT_NOTIFICATION = {
  getPath: (): string => appendPath(ACCOUNT.path, 'notification'),
};

const HELP_CENTER = {
  path: 'help-center',
  getPath: (): string => appendPath(HELP_CENTER.path),
};

const FAQ = {
  getPath: (): string => appendPath(HELP_CENTER.path, 'faq'),
};

const IDME_CALLBACK = {
  getPath: (): string => appendPath('idme/callback'),
};

const AUTH0_SSO_CALLBACK = {
  getPath: (): string => appendPath('lilly/auth0/callback'),
};

const EXTERNAL_OIDC_REGISTRATION = {
  getPath: (token: string): string =>
    appendPath('registration', token, 'external'),
};

export const Routing = {
  BASE_URL,
  HOME,
  REFERRAL_DETAILS,
  LOGIN,
  REGISTER,
  ACCOUNT,
  ACCOUNT_DETAILS,
  ACCOUNT_LANGUAGE,
  FORGOT_PASSWORD,
  CHANGE_PASSWORD,
  ACCOUNT_NOTIFICATION,
  MY_SITES,
  HELP_CENTER,
  FAQ,
  IDME_CALLBACK,
  AUTH0_SSO_CALLBACK,
  EXTERNAL_OIDC_REGISTRATION,
};
